import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import CustomerListResults from 'src/components/StockTransfer/CustomerListResults';
import CustomerListToolbar from 'src/components/StockTransfer/CustomerListToolbar';
import { URL } from '../utils/factory';

const axios = require('axios');

const moment = require('moment');

const StockTransferList = () => {
  const [invoicelist, setInvoicelList] = useState([]);
  const [invoicelistOld, setInvoicelListOld] = useState([]);
  const [changeflag, setChangeFlag] = useState(false);
  const [bookedfilter, setBookedfilter] = useState(2);
  const [statusfilter, setStatusfilter] = useState(0);
  const [fromdate, setFromdate] = useState();
  const [todate, setTodate] = useState();
  const [loaderflag, setLoderFlag] = useState(false);
  const [exportflag, setExportFlag] = useState(true);
  const [exportflagver, setExportFlagVer2] = useState(true);
  const [exportflagverCSV, setExportFlagVerCsv] = useState(true);

  const [invoicelistexport, setInvoicelListExport] = useState([]);
  const [invoicelistexportver, setInvoicelListExportVer] = useState([]);
  const [invoicelistexportcsv, setInvoicelListExportCsv] = useState([]);

  const [searchtext, setSearchText] = useState('');

  const handleExportData = () => {
    // console.log('In Export::::::::::::::');
    setLoderFlag(true);
    const clientid = localStorage.getItem('tranuserid');
    try {
      axios
        .post(`${URL}trans_loaditems_stocktransfer`, {
          userid: clientid,
          qtype: '8',
          searchtext: bookedfilter,
          fdate: fromdate,
          tdate: todate,
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then((response) => {
          if (response.data.d.length > 0) {
            // eslint-disable-next-line no-eval
            const userdata = eval(response.data.d);
            setInvoicelListExport(userdata);
            setExportFlag(false);
            setLoderFlag(false);
          } else {
            setInvoicelListExport([]);
            setExportFlag(false);
            setLoderFlag(false);
          }
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handlebetaversiontwo = () => {
    console.log('In Export ver 2::::::::::::::');
    setLoderFlag(true);
    const clientid = localStorage.getItem('tranuserid');
    try {
      axios
        .post(`${URL}stocktranexportbetav2`, {
          userid: clientid,
          qtype: '1',
          status: bookedfilter,
          invoiceno: searchtext,
          fdate: fromdate,
          tdate: todate,
          invstatus: statusfilter,
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then((response) => {
          if (response.data.d.length > 0) {
            // eslint-disable-next-line no-eval
            const userdata = eval(response.data.d);
            setInvoicelListExportVer(userdata);
            setExportFlagVer2(false);
            setLoderFlag(false);
          } else {
            setInvoicelListExportVer([]);
            setExportFlagVer2(false);
            setLoderFlag(false);
          }
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handelCsvButon = () => {
    console.log('In Export ver 2::::::::::::::');
    setLoderFlag(true);
    const clientid = localStorage.getItem('tranuserid');
    try {
      axios
        .post(`${URL}tranexportcsv`, {
          userid: clientid,
          qtype: '1',
          status: bookedfilter,
          invoiceno: searchtext,
          fdate: fromdate,
          tdate: todate,
          invstatus: statusfilter,
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then((response) => {
          if (response.data.d.length > 0) {
            // eslint-disable-next-line no-eval
            const userdata = eval(response.data.d);
            setInvoicelListExportCsv(userdata);
            setExportFlagVerCsv(false);
            setLoderFlag(false);
          } else {
            setInvoicelListExportCsv([]);
            setExportFlagVerCsv(false);
            setLoderFlag(false);
          }
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleResetFilter = () => {
    setBookedfilter(2);
    setStatusfilter(0);
  };

  const handleDate = (fdate, sdate, bfilter) => {
    console.log('In date::::::::::::::1');
    setExportFlagVer2(true);
    setExportFlagVerCsv(true);
    let fdateformat = '';
    let sdateformat = '';
    fdateformat = new Date(fdate);
    sdateformat = new Date(sdate);
    fdateformat = moment(fdateformat).format('YYYY-MM-DD');
    sdateformat = moment(sdateformat).format('YYYY-MM-DD');

    setFromdate(fdateformat);
    setTodate(sdateformat);
    setBookedfilter(bfilter);

    // handleResetFilter();

    if (fdateformat !== '' && sdateformat !== '') {
      setChangeFlag(true);
      setLoderFlag(true);
      setInvoicelList([]);
      setInvoicelListOld([]);
      // handleExportData(fdate, sdate, bookedfilter);
      const clientid = localStorage.getItem('tranuserid');
      try {
        axios
          .post(`${URL}trans_loaditems_stocktransfer`, {
            userid: clientid,
            qtype: '3',
            searchtext: bfilter,
            fdate: fdateformat,
            tdate: sdateformat,
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
            }
          })
          .then((response) => {
            // console.log('Data Found:::::::::::::', response.data.d.length);
            if (response.data.d.length > 0) {
              // eslint-disable-next-line no-eval
              const userdata = eval(response.data.d);
              setInvoicelList(userdata);
              setInvoicelListOld(userdata);
              setLoderFlag(false);
            } else {
              setInvoicelList([]);
              setInvoicelListOld([]);
              setLoderFlag(false);
            }
          })
          .catch((error) => {
            console.log('API error', error);
          });
      } catch (error) {
        console.log(error);
      }
    }
  };
  const handlesearch = (e, type) => {
    // console.log('Key:::::::::::', type);
    // console.log('eeeee:::::::::::', e);
    if (e.code === 'Enter' || type === '2') {
      if (type === '2' && e === '') {
        handleDate(fromdate, todate, bookedfilter);
        return;
      }
      if (type === '1' && e.target.value === '') return;
      setChangeFlag(true);
      setExportFlagVer2(true);
      setExportFlagVerCsv(true);
      setLoderFlag(true);
      handleResetFilter();
      // if (type === '1') handleExportData(fromdate, todate, e.target.value);
      // else if (type === '2') handleExportData(fromdate, todate, e);
      // console.log('Custmer Search::::::::', e.target.value);
      const clientid = localStorage.getItem('tranuserid');
      try {
        setInvoicelList([]);
        setInvoicelListOld([]);

        axios
          .post(`${URL}trans_loaditems_stocktransfer`, {
            userid: clientid,
            qtype: '1',
            searchtext: type === '1' ? e.target.value : e,
            fdate: '',
            tdate: '',
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
            }
          })
          .then((response) => {
            if (response.data.d.length > 0) {
              // eslint-disable-next-line no-eval
              const userdata = eval(response.data.d);
              setInvoicelList(userdata);
              setInvoicelListOld(userdata);
            } else {
              setInvoicelList([]);
              setInvoicelListOld([]);
            }
            setLoderFlag(false);
          })
          .catch((error) => {
            console.log('API error', error);
            setLoderFlag(false);
          });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getchilddata = (data) => {
    // console.log(data);
    setInvoicelList(data);
    setInvoicelListOld(data);
  };

  const handleChangeSelectSearch = (invoicestatus, bookedstatsus) => {
    setExportFlagVer2(true);
    setExportFlagVerCsv(true);
    let data = invoicelistOld;
    // console.log('STATATATA::::::::', invoicestatus, bookedstatsus);
    if (bookedstatsus === 0) {
      data = invoicelistOld.filter((id) => id.Itd_IsTransBooked === 'Pending');
    } else if (bookedstatsus === 1) {
      data = invoicelistOld.filter((id) => id.Itd_IsTransBooked === 'Booked');
    } else if (invoicestatus === 0 && bookedstatsus === 2) {
      data = invoicelistOld;
    }
    // console.log('STATATATA data::::::::', data);
    if (invoicestatus === 1) {
      data = data.filter((id) => id.Invoicestatus === 'Initiated');
    } else if (invoicestatus === 2) {
      data = data.filter((id) => id.Invoicestatus === 'Assign For Picking');
    } else if (invoicestatus === 3) {
      data = data.filter((id) => id.Invoicestatus === 'Picked');
    } else if (invoicestatus === 4) {
      data = data.filter((id) => id.Invoicestatus === 'Area Assign');
    } else if (invoicestatus === 5) {
      data = data.filter((id) => id.Invoicestatus === 'Ready for dispatch');
    } else if (invoicestatus === 0 && bookedstatsus === 2) {
      data = invoicelistOld;
    }
    // console.log('STATATATA data::::::::', data);
    setInvoicelList(data);
  };
  const handleChangeselect = (event) => {
    // console.log('status:::::::::', event.target.value);
    handleChangeSelectSearch(statusfilter, event.target.value);
    setBookedfilter(event.target.value);
  };

  // const handleChangeselected = (event) => {
  //   // console.log('status:::::::::', event.target.value);
  //   handleChangeSelectSearch(event.target.value, bookedfilter);

  //   setStatusfilter(event.target.value);
  // };

  useEffect(() => {
    let prevdateold = new Date();
    let currentdate = new Date();
    prevdateold = moment(prevdateold).format('MM/DD/YYYY');
    setFromdate(prevdateold);
    currentdate = moment(currentdate).format('MM/DD/YYYY');
    setTodate(currentdate);
    handleDate(prevdateold, currentdate, '2');
  }, []);

  const handleSearchText = (inv) => {
    setSearchText(inv);
  };

  return (
    <>
      <Helmet>
        <title>Invoice List</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <CustomerListToolbar
            clickToSearch={handlesearch}
            handleSearchText={handleSearchText}
            datesearch={handleDate}
            customers={invoicelist}
            handleChangeselect={handleChangeselect}
            // handleChangeselected={handleChangeselected}
            selectvalue={bookedfilter}
            // selectvalues={statusfilter}
            fromdate={fromdate}
            todate={todate}
            handleresetfilter={handleResetFilter}
          />
          <Box sx={{ pt: 3 }}>
            <CustomerListResults
              customers={invoicelist}
              flagstatus={changeflag}
              getchilddata={getchilddata}
              fromdate={fromdate}
              todate={todate}
              datesearch={handleDate}
              bookedfilter={bookedfilter}
              loaderflag={loaderflag}
              exportlist={invoicelistexport}
              handleExportGrid={handleExportData}
              exportflag={exportflag}
              handleExportGridTwo={handlebetaversiontwo}
              exportlisttwo={invoicelistexportver}
              exportflagver={exportflagver}
              exportflagverCSV={exportflagverCSV}
              handelCsvButon={handelCsvButon}
              invoicelistexportcsv={invoicelistexportcsv}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default StockTransferList;
